import { render } from "./ServicePair.vue?vue&type=template&id=fd973056&scoped=true&ts=true"
import script from "./ServicePair.vue?vue&type=script&lang=ts"
export * from "./ServicePair.vue?vue&type=script&lang=ts"

import "./ServicePair.vue?vue&type=style&index=0&id=fd973056&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd973056"]])

export default __exports__